// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HHj5r","topSection":"styles_topSection__RbvAf","actionsRow":"styles_actionsRow__hozqQ","paidOnText":"styles_paidOnText__28v1u"};